import React from 'react';
import { CheckCircle, Check, Package, X } from 'lucide-react';
import { Order, OrderStatus } from '../../types/order';

interface OrderActionsProps {
  order: Order;
  handleConfirmAction: (action: () => void, message: string) => void;
  handleStatusUpdate: (newStatus: OrderStatus, shippingDetails?: any) => void;
  setShowShippingModal: (value: boolean) => void;
}

const OrderActions: React.FC<OrderActionsProps> = ({
  order,
  handleConfirmAction,
  handleStatusUpdate,
  setShowShippingModal
}) => {
  return (
    <div className="bg-white border-b border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-900">Order Actions</h2>
      </div>
      <div className="px-6 py-4">
        <div className="flex flex-wrap gap-3">
          {order.status === 'NEW' && (
            <button
              onClick={() => handleConfirmAction(() => handleStatusUpdate('PENDING'), 'Are you sure you want to verify payment for this order?')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              <CheckCircle className="w-4 h-4 mr-2" />
              Verify Payment
            </button>
          )}

          {order.status === 'PENDING' && (
            <button
              onClick={() => handleConfirmAction(() => handleStatusUpdate('CONFIRMED'), 'Are you sure you want to confirm this order?')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
            >
              <Check className="w-4 h-4 mr-2" />
              Confirm Order
            </button>
          )}

          {order.status === 'CONFIRMED' && (
            <button
              onClick={() => setShowShippingModal(true)}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700"
            >
              <Package className="w-4 h-4 mr-2" />
              Mark as Shipped
            </button>
          )}

          {order.status === 'SHIPPED' && (
            <button
              onClick={() => handleConfirmAction(() => handleStatusUpdate('DELIVERED'), 'Are you sure you want to mark this order as delivered?')}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700"
            >
              <CheckCircle className="w-4 h-4 mr-2" />
              Mark as Delivered
            </button>
          )}

          {['NEW', 'PENDING', 'CONFIRMED'].includes(order.status) && (
            <button
              onClick={() => handleConfirmAction(() => handleStatusUpdate('CANCELLED'), 'Are you sure you want to cancel this order? This action cannot be undone.')}
              className="inline-flex items-center px-4 py-2 border border-red-300 text-sm font-medium rounded-md text-red-700 bg-white hover:bg-red-50"
            >
              <X className="w-4 h-4 mr-2" />
              Cancel Order
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderActions;
